import React, { useState } from 'react';
import { Accordion, Card } from 'react-bootstrap';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';

function OurAccordion({
    title,
    children,
    titleTag = 'h4',
    defaultShow = true,
    style = {},
    titleStyle = {},
    contentStyle = {},
    iconStyle = {},
    contentWrapperStyle = {},
    onToggle = () => {},
    onStateChange = () => {},
    arrowPosition = 'center', // 'center' or 'top-right'
}) {
    const [isOpen, setIsOpen] = useState(defaultShow);
    const handleToggle = () => {
        const next = !isOpen;
        setIsOpen(next);
        onStateChange?.(next);
        if (next) {
            onToggle?.(next);
        }
    };
    const TitleElement = titleTag === 'h4' ? 'h4' : 'div';
    return (
        <div style={style}>
            <Accordion activeKey={isOpen ? '0' : ''}>
                <Accordion.Toggle
                    as={Card.Header}
                    variant="link"
                    eventKey="0"
                    onClick={handleToggle}
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: arrowPosition === 'top-right' ? 'flex-start' : 'center',
                        cursor: 'pointer',
                        ...titleStyle,
                    }}
                >
                    <TitleElement style={{ flex: 1, margin: 0 }}>{title}</TitleElement>
                    <div
                        style={{
                            ...(arrowPosition === 'top-right' && { marginTop: '-4px' }),
                        }}
                    >
                        {isOpen ? (
                            <FaCaretUp size="24" style={iconStyle} />
                        ) : (
                            <FaCaretDown size="24" style={iconStyle} />
                        )}
                    </div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0" style={{ ...contentStyle }}>
                    <Card.Body style={contentWrapperStyle}>{children}</Card.Body>
                </Accordion.Collapse>
            </Accordion>
        </div>
    );
}

export default OurAccordion;
